import { render, staticRenderFns } from "./WarehouseItemStats.vue?vue&type=template&id=eda35a66&"
import script from "./WarehouseItemStats.vue?vue&type=script&lang=js&"
export * from "./WarehouseItemStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports